import React from 'react';
import { useTranslation } from 'react-i18next';
import { 
  FaHospital, 
  FaClinicMedical, 
  FaBuilding, 
  FaBoxOpen, 
  FaUniversity, 
  FaStore, 
  FaTruck, 
  FaUserMd, 
  FaHandHoldingHeart, 
  FaGraduationCap, 
  FaHandshake,
  FaUserFriends
} from 'react-icons/fa';
import { MdLocalPharmacy } from "react-icons/md";
import './DataSystemModel.scss';

const DataSystemModel = () => {
  const { t } = useTranslation();

  const gridItems = [
    { id: 1, icon: <FaHospital />, label: t('data_system_model.hospital'), color: '#1a365d' },
    { id: 2, icon: <MdLocalPharmacy />, label: t('data_system_model.pharmacy'), color: '#16a34a' },
    { id: 3, icon: <FaBuilding />, label: t('data_system_model.real_estate'), color: '#475569' },
    { id: 4, icon: <FaBoxOpen />, label: t('data_system_model.supplier'), color: '#b45309' },
    { id: 5, icon: <FaClinicMedical />, label: t('data_system_model.clinic'), color: '#ef4444' },
    { id: 6, icon: <FaUniversity />, label: t('data_system_model.bank'), color: '#3b82f6' },
    { id: 7, icon: <FaStore />, label: t('data_system_model.supermarket'), color: '#f59e0b' },
    { id: 8, icon: <FaTruck />, label: t('data_system_model.delivery'), color: '#10b981' },
    { id: 9, icon: <FaUserMd />, label: t('data_system_model.doctor'), color: '#0ea5e9' },
    { id: 10, icon: <FaHandHoldingHeart />, label: t('data_system_model.insurance'), color: '#6366f1' },
    { id: 11, icon: <FaGraduationCap />, label: t('data_system_model.education'), color: '#8b5cf6' },
    { id: 12, icon: <FaHandshake />, label: t('data_system_model.other_services'), color: '#64748b' }
  ];

  return (
    <div className="data-system-model-wrapper">
      <h2 className="dsm-title">{t('data_system_model.title')}</h2>
      
      <div className="dsm-container">
        
        {/* Left Section - Main Partner */}
        <div className="dsm-left">
          <div className="partner-illustration">
            <FaUserFriends className="illustration-icon" />
          </div>
          <div className="main-partner-box">
            {t('data_system_model.main_partner')}
          </div>
        </div>

        {/* Center Arrow */}
        <div className="dsm-arrow">
          <div className="arrow-body"></div>
          <div className="arrow-head"></div>
        </div>

        {/* Right Section - Grid */}
        <div className="dsm-right">
          <div className="dsm-grid">
            {gridItems.map((item) => (
              <div key={item.id} className="grid-item">
                <div className="icon-wrapper" style={{ color: item.color }}>
                  {item.icon}
                </div>
                <div className="item-label">
                  {item.label}
                </div>
              </div>
            ))}
          </div>
        </div>
        
      </div>
    </div>
  );
};

export default DataSystemModel;
